import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { BaseEventTracking } from '@/modules/core/app/models/abstracts/BaseEventTracking';
import { EstateType } from '@/modules/estate/enums/EstateType';

export class PaywallPaymentModalViewedEventTracking extends BaseEventTracking {
  static eventName: SegmentEvent = SegmentEvent.PAYWALL_PAYMENT_MODAL_VIEWED;
  email?: string;
  name?: string;
  jurisdiction?: string;
  redirected_from?: string;
  billing_plan?: string;
  company?: string;
  type?: string;
  clicked_from_url?: string;

  constructor(
    eventProperties: Partial<PaywallPaymentModalViewedEventTracking> = {},
    clickedFromUrl?: string
  ) {
    super();
    this.email = eventProperties?.email;
    this.name = eventProperties?.name;
    this.jurisdiction = eventProperties?.jurisdiction;
    this.redirected_from = eventProperties?.redirected_from;
    this.billing_plan = eventProperties?.billing_plan;
    this.company = eventProperties?.company;
    this.type = EstateType.CLEAR_VAULT.key;
    this.clicked_from_url = clickedFromUrl;
  }
}
